export default __webpack_public_path__ + "static/media/error-page.d675e5f1.svg";